import React from "react";
import "./Radio.css";

import RadioButtonInactive from "../../assets/radial-filter-button-OFF.svg";

export const RadioInactive = () => {
  return (
    <img
      className="delicious100-interactive__radio-button"
      src={RadioButtonInactive}
      alt="RadioButtonInactive"
    ></img>
  );
};
